const defaultTranslation = {
  selectedRowCountText: 'selectedRowCountText',
  filteredWithText: 'filteredWith'
};

export { defaultTranslation };
